import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  PopoverOrigin,
  IconButton,
  Popover,
  Typography,
  useTheme,
  Box,
} from "@mui/material";
import { useState } from "react";

type Props = {
  anchorOrigin: PopoverOrigin;
  transformOrigin: PopoverOrigin;
  content: string;
};

export const Q3DHintPopover = (props: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const theme = useTheme();

  const popoverStyle = {
    color: theme.palette.base.contrast,
    fontSize: "14px",
    padding: "0px",
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const replaceNewLine = (s: String) => {
  //   return s.split("\n").map((line) => (
  //     <span>
  //       {line}
  //       <br />
  //     </span>
  //   ));
  // };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        onClick={handleClick}
        style={{ padding: "0px", marginLeft: "5px" }}
      >
        <FontAwesomeIcon icon={faCircleQuestion} style={popoverStyle} />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={props.anchorOrigin}
        transformOrigin={props.transformOrigin}
        PaperProps={{
          sx: {
            padding: "8px 16px",
            backgroundColor: theme.palette.base.sub,
            color: theme.palette.base.contrast,
            maxWidth: "400px",
          },
        }}
      >
        <Typography
          style={{
            whiteSpace: "pre-wrap",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* {props.content ? replaceNewLine(props.content) : ""} */}
          {props.content ? props.content : ""}
        </Typography>
      </Popover>
    </>
  );
};
